import { render } from "./ListShopping.vue?vue&type=template&id=c16abd98"
import script from "./ListShopping.vue?vue&type=script&lang=js"
export * from "./ListShopping.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__